import { generateKeys, generateLocalization } from '../utils';
export const walkthroughMessages = generateLocalization('walkthroughMessages', generateKeys({
    step1Title: {
        value: 'step1Title',
        label: 'Welcome to BDSwiss',
        localization: { id: '', defaultMessage: '' },
    },
    step1Body: {
        value: 'step1Body',
        label: 'You’ll now learn how to place your first trade on a practice account. ' +
            'It takes less than 15 seconds and over 93% of clients take this step.',
        localization: { id: '', defaultMessage: '' },
    },
    step2Title: {
        value: 'step2Title',
        label: 'First Trade',
        localization: { id: '', defaultMessage: '' },
    },
    step2Body: {
        value: 'step2Body',
        label: 'Your first trade will be on a practice account. ' +
            'We\'ve chosen Bitcoin as it’s available to trade 24/7.',
        localization: { id: '', defaultMessage: '' },
    },
    step3Title: {
        value: 'step3Title',
        label: 'Investment Amount',
        localization: { id: '', defaultMessage: '' },
    },
    step3Body: {
        value: 'step3Body',
        label: 'Choose your investment amount.',
        localization: { id: '', defaultMessage: '' },
    },
    step4Title: {
        value: 'step4Title',
        label: 'Select Amount',
        localization: { id: '', defaultMessage: '' },
    },
    step4Body: {
        value: 'step4Body',
        label: 'The investment amount is the amount of your account balance required to open the trade. ' +
            'It is possible for the trade to gain or lose more than the investment amount.',
        localization: { id: '', defaultMessage: '' },
    },
    step5Title: {
        value: 'step5Title',
        label: 'Buy Or Sell?',
        localization: { id: '', defaultMessage: '' },
    },
    step5Body: {
        value: 'step5Body',
        label: 'Do you think the price of Bitcoin will go up or down? ' +
            'Click BUY if you think the price of Bitcoin will increase in value. ' +
            'Click SELL if you think  the price of Bitcoin will decrease in value.',
        localization: { id: '', defaultMessage: '' },
    },
    step6Title: {
        value: 'step6Title',
        label: 'Congratulations!',
        localization: { id: '', defaultMessage: '' },
    },
    step6Body: {
        value: 'step6Body',
        label: 'You opened your first trade. Click on this icon to see your open positions. ' +
            'To make your first real money trade, please deposit funds. Good Luck!',
        localization: { id: '', defaultMessage: '' },
    },
    step1TitleV2: {
        value: 'step1TitleV2',
        label: 'Welcome to BDSwiss',
        localization: { id: '', defaultMessage: '' },
    },
    step1BodyV2: {
        value: 'step1BodyV2',
        label: 'You’ll now learn how to place your first trade on a practice account. ' +
            'It takes less than 15 seconds and over 93% of clients take this step.',
        localization: { id: '', defaultMessage: '' },
    },
    step2TitleV2: {
        value: 'step2TitleV2',
        label: 'First Trade',
        localization: { id: '', defaultMessage: '' },
    },
    step2BodyV2: {
        value: 'step2BodyV2',
        label: 'Your first trade will be on a practice account. ' +
            'We\'ve chosen Bitcoin as it’s available to trade 24/7.',
        localization: { id: '', defaultMessage: '' },
    },
    step3TitleV2: {
        value: 'step3TitleV2',
        label: 'Investment Amount',
        localization: { id: '', defaultMessage: '' },
    },
    step3BodyV2: {
        value: 'step3BodyV2',
        label: 'Choose your investment amount.',
        localization: { id: '', defaultMessage: '' },
    },
    step4TitleV2: {
        value: 'step4TitleV2',
        label: 'Buy Or Sell?',
        localization: { id: '', defaultMessage: '' },
    },
    step4BodyV2: {
        value: 'step4BodyV2',
        label: 'Do you think the price of Bitcoin will go up or down? ' +
            'Click BUY if you think the price of Bitcoin will increase in value. ' +
            'Click SELL if you think  the price of Bitcoin will decrease in value.',
        localization: { id: '', defaultMessage: '' },
    },
    step5TitleV2: {
        value: 'step5TitleV2',
        label: 'Congratulations!',
        localization: { id: '', defaultMessage: '' },
    },
    step5BodyV2: {
        value: 'step5BodyV2',
        label: 'You opened your first trade. Click on this icon to see your open positions. ' +
            'To make your first real money trade, please deposit funds. Good Luck!',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const walkthrough = generateKeys({
    step1: {
        title: walkthroughMessages.step1Title,
        body: walkthroughMessages.step1Body,
        step: 1,
        next: true,
    },
    step2: {
        title: walkthroughMessages.step2Title,
        body: walkthroughMessages.step2Body,
        step: 2,
        next: true,
    },
    step3: {
        title: walkthroughMessages.step3Title,
        body: walkthroughMessages.step3Body,
        step: 3,
        next: false,
    },
    step4: {
        title: walkthroughMessages.step4Title,
        body: walkthroughMessages.step4Body,
        step: 4,
        next: false,
    },
    step5: {
        title: walkthroughMessages.step5Title,
        body: walkthroughMessages.step5Body,
        step: 5,
        next: false,
    },
    step6: {
        title: walkthroughMessages.step6Title,
        body: walkthroughMessages.step6Body,
        step: 6,
        next: false,
    },
});
export const walkthroughV2 = generateKeys({
    step1: {
        title: walkthroughMessages.step1TitleV2,
        body: walkthroughMessages.step1BodyV2,
        step: 1,
        next: true,
    },
    step2: {
        title: walkthroughMessages.step2TitleV2,
        body: walkthroughMessages.step2BodyV2,
        step: 2,
        next: true,
    },
    step3: {
        title: walkthroughMessages.step3TitleV2,
        body: walkthroughMessages.step3BodyV2,
        step: 3,
        next: true,
    },
    step4: {
        title: walkthroughMessages.step4TitleV2,
        body: walkthroughMessages.step4BodyV2,
        step: 4,
        next: false,
    },
    step5: {
        title: walkthroughMessages.step5TitleV2,
        body: walkthroughMessages.step5BodyV2,
        step: 5,
        next: false,
    },
});
export const walkthroughVersions = {
    v1: {
        steps: walkthrough,
        default: true,
    },
    v2: {
        steps: walkthroughV2,
    },
};
